<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Course Finances
    </h5>
    <div class="row">
      <div class="col-6">
        Total Income
      </div>
      <div class="col-6 text-right">
        {{ formatCurrency(budget.ActualIncome) }}
      </div>
    </div>
    <div
      class="row"
    >
      <div class="col-6">
        Total Expenses
      </div>
      <div class="col-6 text-right">
        {{ formatCurrency(budget.ActualExpenses) }}
      </div>
    </div>
    <div
      class="row"
    >
      <div class="col-6">
        Net Proceeds
      </div>
      <div
        class="col-6 text-right"
      >
        {{ formatCurrency(budget.ActualProfit) }}
      </div>
    </div>
    <router-link
      to="/staff/finances"
      class="row"
    >
      <div class="col-6">
        % Budget Spent
      </div>
      <div class="col-6 text-right">
        {{ formatPercent(budget.ExpenseToBudget) }}
      </div>
    </router-link>
  </card>
</template>

<script>
import budgetApi from '@/services/api/budget.js'
import formatter from '@/services/formatter.js'

export default {
  name: 'HomeStaffFinances',
  props: {
    errormsg: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      budget: {}
    }
  },
  mounted: function () {
    budgetApi.getBudgetWithActuals(this.$root.courseKey)
      .then(x => {
        this.budget = x.Budget
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    formatCurrency: function (value) {
      return formatter.formatAsCurrency(value)
    },
    formatPercent: function (value) {
      return formatter.formatAsPercent(value)
    }
  }
}
</script>
